import type { ComponentProps } from 'react';

export type IChatFrameworkInputBoxSendIcon = {
  state?: 'active' | 'inactive';
} & ComponentProps<'svg'>;

const opacityMapping = {
  active: '1',
  inactive: '0.5',
};

const ChatFrameworkInputBoxSendIcon = ({
  state = 'active',
  ...props
}: IChatFrameworkInputBoxSendIcon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <g opacity={opacityMapping[state]}>
      <rect width="32" height="32" rx="16" fill="#EE4F5E" />
      <path
        d="M13.3435 17.1062L7.57831 14.8523L19.7758 10.6739L13.3435 17.1062ZM14.7576 18.5203L21.1899 12.088L17.0115 24.2855L14.755 18.5229L14.7576 18.5203ZM5.22584 13.5929C4.7526 13.7539 4.46974 14.2135 4.51832 14.7365C4.56691 15.2594 4.94289 15.7437 5.4511 15.9425L12.9755 18.8883L15.9213 26.4127C16.1201 26.9209 16.6015 27.294 17.1273 27.3455C17.6532 27.397 18.1073 27.1138 18.2738 26.6409L24.1672 9.43482C24.3241 8.9833 24.1783 8.44563 23.8012 8.06854C23.4241 7.69145 22.8864 7.54564 22.4349 7.70255L5.22879 13.5959L5.22584 13.5929Z"
        fill="white"
      />
    </g>
  </svg>
);

export default ChatFrameworkInputBoxSendIcon;
